import React, { useContext, useState, useEffect } from "react";
import { useFormik, Form, FormikProvider } from "formik";
import * as Yup from "yup";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import {
  Grid,
  Stack,
  Button,
  TextField,
  Typography,
  IconButton,
  FormControl,
  Select,
  MenuItem,
  InputAdornment,
  Box,
  Tab,
} from "@mui/material";
import TabContext from "@mui/lab/TabContext";
import TabList from "@mui/lab/TabList";
import TabPanel from "@mui/lab/TabPanel";
import { BiMinusCircle } from "react-icons/bi";
//date picker
import { useMutation } from "@apollo/client";
//src
import "../../Style/dialogstyle.scss";

import { CHECK_REQ_PURCHASE } from "../../Schema/Reqpurchase";
import { AuthContext } from "../../Context/AuthContext";
import ListPurchase from "./ListPurchase";

const CheckReqPurchase = ({
  open,
  handleClose,
  checkReqPurchaseData,
  editData,
  setRefetch,
  dialogTitle,
}) => {
  const { setAlert } = useContext(AuthContext);
  const [loading, setLoading] = useState(false);
  const [submitStutus, setSubmitStatus] = useState("");
  const [isDisabled, setIsDisabled] = useState(false);
  //tab
  const [value, setValue] = useState("2");

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  // Function to toggle the disabled state
  const toggleDisabled = () => {
    setIsDisabled(!isDisabled);
  };

  const [requireField, setRequireField] = useState(false);
  const calculateSubTotal = () => {
    let subTotal = 0;
    listData.forEach((item) => {
      subTotal +=
        (parseFloat(item.unitPrice) || 0) * (parseFloat(item.qty) || 0);
    });
    return subTotal.toFixed(2);
  };
  const calculateSubReqTotal = () => {
    let subTotal = 0;
    reqListData.forEach((item) => {
      subTotal +=
        (parseFloat(item.unitPrice) || 0) * (parseFloat(item.qty) || 0);
    });
    return subTotal.toFixed(2);
  };

  const listReqPurchMaterial = {
    materialId: { id: "", title: "" },
    listMaterialUnitId: { id: "", title: "", imageSrc: "" },
    unitPrice: 0,
    key: Date.now() + Math.random(),
  };

  const [listData, setListData] = useState([listReqPurchMaterial]);
  const [reqListData, setReqListData] = useState([]);

  //checkReqPurchase
  const [checkReqPurchase] = useMutation(CHECK_REQ_PURCHASE, {
    onCompleted: ({ checkReqPurchase }) => {
      setLoading(false);
      if (checkReqPurchase?.status) {
        setAlert(true, "success", checkReqPurchase?.message);
        handleClose();
        setRefetch();
      } else {
        setAlert(true, "error", checkReqPurchase?.message);
      }
    },
    onError: (error) => {
      setLoading(false);
      setAlert(true, "error", error?.message);
      // console.log("error::", error)
    },
  });
  //formik
  const CheckValidation = Yup.object().shape({
    status: Yup.string().required("ទាមទារ!"),
    remark: Yup.string(),
    shippingFee: Yup.number().min(0),
  });

  const formik = useFormik({
    initialValues: {
      status: "Pending",
      remark: "",
      shippingFee: 0,
    },
    validationSchema: CheckValidation,
    onSubmit: async (values) => {
      let createStatus = false;
      const BreakException = {};
      try {
        if (listData?.length !== 0) {
          listData?.forEach(function (elem) {
            if (
              elem?.materialId?.id !== undefined &&
              elem?.materialId?.id !== "" &&
              elem?.listMaterialUnitId?.id !== undefined &&
              elem?.listMaterialUnitId?.id !== "" &&
              elem?.unitPrice > 0 &&
              elem?.qty > 0
            ) {
              createStatus = true;
            } else {
              setLoading(false);
              setRequireField(true);
              createStatus = false;
              throw BreakException;
            }
          });
        } else {
          setLoading(false);
          setRequireField(true);
        }
      } catch (e) {
        if (e !== BreakException) throw e;
      }

      if (createStatus) {
        let listReqPurchMaterialToSubmit = listData.map((d) => {
          return {
            listMaterialUnitId: d?.listMaterialUnitId?.id,
            unitPrice: d?.unitPrice,
            qty: d?.qty,
            key: d?.key,
          };
        });
        // setLoading(true);

        checkReqPurchase({
          variables: {
            id: editData?._id,

            ...values,
            status: submitStutus === "Approved" ? "Approved" : "Rejected",
            //   type: "Purchase",
            checkMaterials: listReqPurchMaterialToSubmit,
          },
        });
      }
    },
  });

  const {
    errors,
    touched,
    handleSubmit,
    getFieldProps,
    setFieldValue,
    values,
  } = formik;

  const total =
    parseFloat(calculateSubTotal()) + parseFloat(values?.shippingFee);
  const totalReq =
    parseFloat(calculateSubReqTotal()) + parseFloat(values?.shippingFee);

  useEffect(() => {
    if (editData) {
      setFieldValue("remark", editData?.remark ?? "");
      setFieldValue("shippingFee", editData?.shippingFee);
    }

    if (editData?.requestMaterials?.length !== 0) {
      const dataFromBackend = editData?.requestMaterials?.map((d) => {
        // console.log("ddddd",d?.listMaterialUnitId?.imageSrc);
        return {
          key: Date.now() + Math.random(),
          materialId: {
            id: d?.listMaterialUnitId?.materialId?._id,
            title: d?.listMaterialUnitId?.materialId?.materialEnName,
          },
          listMaterialUnitId: {
            id: d?.listMaterialUnitId?._id,
            title: d?.listMaterialUnitId?.unitId?.unitKhName,
            imageSrc: d?.listMaterialUnitId?.imageSrc,
          },
          qty: d?.qty,
          unitPrice: d?.unitPrice,
        };
      });
      // console.log("dataFromBackend::", dataFromBackend)
      setListData([...dataFromBackend]);
    }
  }, [open, editData]);

  console.log("editData::", editData);

  return (
    <Dialog open={open} className="dialog-container" fullWidth maxWidth="lg">
      <DialogTitle sx={{ padding: "10px 15px 10px 20px" }}>
        <Stack direction="row" justifyContent="space-between">
          <Stack direction="column" justifyContent="center">
            <Typography className="dialog-title">ពិនិត្យការស្នើទិញ</Typography>
          </Stack>
          <Stack direction="column" justifyContent="center">
            <IconButton onClick={handleClose}>
              <BiMinusCircle className="close-icon" />
            </IconButton>
          </Stack>
        </Stack>
      </DialogTitle>
      <DialogContent dividers>
        <FormikProvider value={formik}>
          <Form noValidate autoComplete="off" onSubmit={handleSubmit}>
            <Grid container rowSpacing={2} columnSpacing={3}>
              <Grid item xs={12}>
                <Typography className="dialog-title-view">សម្ភារៈ</Typography>
              </Grid>

              {/* List of Purchases */}
              <Grid item xs={12}>
                <ListPurchase
                  listData={listData}
                  setListData={setListData}
                  requireField={requireField}
                />
              </Grid>

              {/* Total Calculation */}
              <Grid item xs={4}>
                <Stack direction="column" spacing={1}>
                  <Stack direction="row" width="100%">
                    <Stack width={"32%"}>
                      <Typography className="total-title">តម្លៃ</Typography>
                    </Stack>
                    <Stack width={"18%"}>
                      <Typography className="total-title">:</Typography>
                    </Stack>
                    <Stack
                      direction={"row"}
                      width={"50%"}
                      justifyContent={"space-between"}
                      className="total-boz"
                    >
                      <Typography className="total-boz-letter">$</Typography>
                      <Typography className="total-boz-letter">
                        {calculateSubTotal()}
                      </Typography>
                    </Stack>
                  </Stack>

                  <Stack direction="row" width={"100%"}>
                    <Stack justifyContent="center" width={"32%"}>
                      <Typography className="total-title">
                        ថ្លៃដឹកជញ្ជូន
                      </Typography>
                    </Stack>
                    <Stack justifyContent="center" width={"18%"}>
                      <Typography>:</Typography>
                    </Stack>
                    <Stack
                      direction={"row"}
                      width={"50%"}
                      justifyContent={"space-between"}
                      className="total-boz"
                    >
                      <TextField
                        inputProps={{ min: 0 }}
                        className="text-field-right"
                        fullWidth
                        type="number"
                        value={editData?.shippingFee}
                        size="small"
                        InputProps={{
                          startAdornment: (
                            <InputAdornment position="start">$</InputAdornment>
                          ),
                        }}
                        sx={{
                          "& .css-1ua80n0-MuiInputBase-input-MuiOutlinedInput-input":
                            { textAlign: "right" },
                        }}
                      />
                    </Stack>
                  </Stack>

                  <Stack direction="row" width={"100%"}>
                    <Stack justifyContent="center" width={"32%"}>
                      <Typography className="total-title">តម្លៃសរុប</Typography>
                    </Stack>
                    <Stack justifyContent="center" width={"18%"}>
                      <Typography className="total-title">:</Typography>
                    </Stack>
                    <Stack
                      direction={"row"}
                      width={"50%"}
                      justifyContent={`space-between`}
                      className="total-boz"
                    >
                      <Typography className="total-boz-letter">$</Typography>
                      <Typography className="total-boz-letter">
                        {total ? total.toFixed(2) : "0.00"}
                      </Typography>
                    </Stack>
                  </Stack>
                </Stack>
              </Grid>

              {/* Remarks */}
              <Grid item xs={12}>
                <Typography className="field-title">មតិយោបល់</Typography>
                <TextField
                  className="text-field"
                  fullWidth
                  multiline
                  size="small"
                  placeholder="remark"
                  {...getFieldProps("remark")}
                />
              </Grid>

              {/* Action Buttons */}
              <Grid item xs={6}>
                {loading ? (
                  <Button className="btn-delete" fullWidth>
                    កំពុងដំណើរការ...
                  </Button>
                ) : (
                  <Button
                    className="btn-delete"
                    fullWidth
                    onClick={() => {
                      setSubmitStatus("Rejected");
                      handleSubmit();
                    }}
                  >
                    បដិសេធ
                  </Button>
                )}
              </Grid>
              <Grid item xs={6}>
                {loading ? (
                  <Button className="btn-create" fullWidth>
                    កំពុងដំណើរការ...
                  </Button>
                ) : (
                  <Button
                    className="btn-create"
                    fullWidth
                    onClick={() => {
                      setSubmitStatus("Approved");
                      handleSubmit();
                    }}
                  >
                    អនុម័ត
                  </Button>
                )}
              </Grid>
            </Grid>
          </Form>
        </FormikProvider>
      </DialogContent>
    </Dialog>
  );
};

export default CheckReqPurchase;
